import { StyledMenu } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { Plus } from 'baseui/icon';
import { StatefulPopover } from 'baseui/popover';
import { FIELD_TYPE_OPTIONS } from '../../constants/forms';
import { FieldType } from '../../types/forms';

type Props = {
  size?: 'default' | 'compact' | 'mini';
  onSelection: (item: { id: FieldType; label: string }) => void;
  hidden?: boolean;
};
export function AddFormFieldButton({ size = 'default', onSelection, hidden = false }: Readonly<Props>) {
  return (
    <StatefulPopover
      returnFocus
      content={({ close }) => (
        <StyledMenu
          items={FIELD_TYPE_OPTIONS}
          onItemSelect={(opt) => {
            onSelection(opt.item);
            close();
          }}
        />
      )}
    >
      <Button
        kind="primary"
        shape="round"
        size={size}
        overrides={{
          Root: {
            style: {
              visibility: hidden ? 'hidden' : 'visible',
            },
          },
        }}
      >
        <Plus size={12} />
      </Button>
    </StatefulPopover>
  );
}
